// 소리 층의 잠김 이유 코드를 지금 언어의 문장으로 옮긴다
//
// 소리 층(`signal.ts` 의 `describeBlockedState`)은 언어를 모르므로 문장이 아니라 이유 코드를 넘긴다
// (2026-10-04 T6 개정 둘째, 사용자). 예전에는 한국어 문장을 넘겨 영어 화면에서도 한국어가 떴다. 그 코드를
// 그리는 화면이 둘(열람 화면의 신호 존과 계측 프로브)이라 옮기는 자리를 여기 하나로 둔다. 하나만 고치면
// 다른 화면에 날 코드가 뜬다(다섯째 판 적대 리뷰가 프로브에서 잡았다).

import { view as viewStrings, type Lang } from '../../i18n/index.ts'
import { AUDIO_CLOSED, AUDIO_NOT_RUNNING, AUDIO_SUSPENDED } from './signal.ts'

/** 이유 코드면 지금 언어의 문장으로, 아니면(이미 옮긴 문장이나 다른 안내) 그대로 돌려준다. */
export function blockedReasonText(reason: string, lang: Lang): string {
  const t = viewStrings(lang)
  if (reason === AUDIO_SUSPENDED) return t.audioSuspended
  if (reason === AUDIO_CLOSED) return t.audioClosed
  if (reason.startsWith(AUDIO_NOT_RUNNING)) {
    return t.audioNotRunning.replaceAll('{state}', reason.slice(AUDIO_NOT_RUNNING.length))
  }
  return reason
}
